import { Dialog } from 'primereact/dialog';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import refreshTokenOrLogout from '../../utils/refreshTokenOrLogout';
import { isTokenExpired } from '../../utils/isTokenExpired';
import { LearnosityRequest } from '../../models/LearnosityRequest';
import { usePostHog } from '@posthog/react';
import { ErrorBoundaryUI } from '../ErrorBoundary/ErrorBoundaryUI';
import {
  useLearnosityItemsInitialization,
  type LearnosityInitializationRefetch,
} from '../../custom-hooks/useLearnosityItemsInitialization';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  request: LearnosityRequest;
  refetchInitialization: LearnosityInitializationRefetch;
  setOpenLearnosityModal?: Dispatch<SetStateAction<boolean>>;
}

const AssessmentCompletedReviewDialog: FC<Props> = ({
  visible,
  setVisible,
  request,
  refetchInitialization,
  setOpenLearnosityModal,
}) => {
  const { getAccessTokenSilently, logout } = useAuth0();
  const posthog = usePostHog();
  const [dialogMounted, setDialogMounted] = useState(false);

  const checkTokenRefresh = async () => {
    if (isTokenExpired()) {
      await refreshTokenOrLogout(getAccessTokenSilently, logout, posthog);
    }
  };

  const { status } = useLearnosityItemsInitialization({
    reloadOn10001AfterReady: true,
    initObj: request,
    enabled: visible && dialogMounted,
    assessmentType: 'assessment_review',
    refetchInitialization,
    getContainer: () => document.getElementById('learnosity_assess'),
    onReady: itemsApp => {
      itemsApp.on('test:start', () => {
        void checkTokenRefresh();
      });
    },
  });

  return (
    <Dialog
      visible={visible}
      onShow={() => setDialogMounted(true)}
      onHide={() => {
        setDialogMounted(false);
        setVisible(false);
        setOpenLearnosityModal && setOpenLearnosityModal(false);
      }}
      header={<h3 className="tw-font-sora tw-font-bold tw-text-lg">Skill challenge - Review errors</h3>}
      style={{ width: '75vw', height: '73vh', zIndex: 0 }}
      pt={{ closeButton: { 'aria-label': 'Close' } }}
    >
      {status === 'failed' && <ErrorBoundaryUI embedded />}
      <div id="singleSkillAssessment" hidden={status === 'failed'}>
        <div id="learnosity_assess"></div>
      </div>
    </Dialog>
  );
};

export default AssessmentCompletedReviewDialog;
